const refs = {
  productList: document.querySelector('.product-list'),
  searchField: document.querySelector('.js-input'),
  categoryField: document.querySelector('#categoryField'),
  abcField: document.querySelector('#abcField'),
  form: document.querySelector('.form'),
  productList: document.querySelector('.product-list'),
  emailForm: document.querySelector('.subscribe-form'),
  emailInput: document.querySelector('.subscribe-input'),
  sendBtn: document.querySelector('.send-btn'),
  popularProductList: document.querySelector('.popular-products'),
  totalAmountDisplay: document.querySelector('.total-amount'),
  cartList: document.querySelector('.cart-product-list'),

  deleteAllButton: document.getElementById('deleteAllButton'),

  productsCount: document.getElementById('product-count'),
  dicsProd: document.querySelector('.discount-product-list'),
  discProdList: document.querySelector('.discount-product-list'),
  paginationContainer: document.getElementById('pagination-container'),
  popularProductList: document.querySelector('.popular_products_list'),
  productsCountHeader: document.querySelector('#product-count-header'),
  divHome: document.querySelector('.home-sections'),
  // modalCloseBtn: document.querySelector('.js-modal-close'),
};

export { refs };
